import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { TimeSheetFilter } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  reloadTimeSheet(request: Boundaries["reloadTimeSheet"]["request"]): void;
}

function useReloadTimeSheet(filter: TimeSheetFilter): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isReloadTimeSheetRequestPending(filter),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isReloadTimeSheetRequestSuccess(filter),
    ),
    isRequestFailure: useSelector(() =>
      selector.isReloadTimeSheetRequestFailure(filter),
    ),
    reloadTimeSheet: core.reloadTimeSheet,
  };
}

export { useReloadTimeSheet };
